import React from 'react';

/**
 * 검색 & 정렬 섹션 컴포넌트
 */
function SearchSortSection() {
  return (
    <section id="search-sort" className="guide-section">
      <h2>🔍 검색 & 정렬</h2>
      
      <div className="feature-grid">
        <div className="feature-card">
          <h3>🔍 실시간 검색</h3>
          <div className="feature-steps">
            <p><strong>검색 방법:</strong></p>
            <ul>
              <li>검색창에 키워드 입력 (300ms 디바운스)</li>
              <li>제목, 웹사이트, 사용자명에서 검색</li>
              <li>대소문자 구분 없이 검색</li>
            </ul>
            
            <div className="example-box">
              <strong>예시:</strong><br/>
              "google" 검색 → Google, google.com 모두 검색
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>📂 카테고리 필터</h3>
          <div className="feature-steps">
            <p><strong>필터 옵션:</strong></p>
            <ul>
              <li>🌐 웹사이트 (소셜, 쇼핑, 업무 등)</li>
              <li>📧 이메일 서비스</li>
              <li>💰 금융 서비스</li>
              <li>🎮 게임 & 엔터테인먼트</li>
            </ul>
            
            <p><strong>사용법:</strong></p>
            <ol>
              <li>카테고리 드롭다운 선택</li>
              <li>원하는 카테고리 클릭</li>
              <li>해당 카테고리 패스워드만 표시</li>
            </ol>
          </div>
        </div>

        <div className="feature-card">
          <h3>📅 날짜 필터</h3>
          <div className="feature-steps">
            <p><strong>기간 옵션:</strong></p>
            <ul>
              <li>📅 오늘 추가된 항목</li>
              <li>📆 1주일 이내</li>
              <li>🗓️ 1개월 이내</li>
              <li>📋 3개월 이내</li>
            </ul>
            
            <div className="tip-box">
              <strong>💡 활용:</strong> 최근 추가한 패스워드를 빠르게 찾을 때 유용합니다.
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>🔄 정렬 기능</h3>
          <div className="feature-steps">
            <p><strong>정렬 옵션:</strong></p>
            <ul>
              <li>📝 제목순 (A-Z, Z-A)</li>
              <li>👤 사용자명순</li>
              <li>🌐 웹사이트순</li>
              <li>📅 생성일순 (최신/오래된 순)</li>
            </ul>
            
            <p><strong>조합 사용:</strong></p>
            <ol>
              <li>검색 + 필터 + 정렬 동시 적용 가능</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SearchSortSection;